import { objectToCamel } from 'ts-case-convert';

import { SectionNameEnum } from '@app/enums';
import { HomepageDataESModel, HomepageDataModel } from '@app/models/elastic-search';
import { HomepagePayloadMutators } from '@app/state/slices/homepage/homepage.types';

const sectionPayloadMutator =
    <T extends keyof HomepageDataESModel>(section: T) =>
    (
        currentState: Partial<HomepageDataModel>,
        input: HomepageDataESModel[T],
    ): Partial<HomepageDataModel> => ({
        ...currentState,
        [section]: objectToCamel(input as object),
    });

// for each page section a dedicated mutator should be added here
const featuredCountriesSectionPayloadMutator = sectionPayloadMutator(
    SectionNameEnum.FeaturedCountriesSection,
);
const popularTravelDestinationsSectionPayloadMutator = sectionPayloadMutator(
    SectionNameEnum.PopularTravelDestinations,
);

export const homepagePayloadMutators: HomepagePayloadMutators = {
    [SectionNameEnum.FeaturedCountriesSection]: featuredCountriesSectionPayloadMutator,
    [SectionNameEnum.PopularTravelDestinations]: popularTravelDestinationsSectionPayloadMutator,
};
